exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-photo[data-v-750fd9e2]{width:2rem;height:2rem;margin:-.375rem 0}.bolinha[data-v-750fd9e2]{position:absolute!important;top:-5px;right:-5px;background:#da7900;border-radius:50%;padding:10px;text-align:center;vertical-align:middle;position:relative;color:#fff;font-size:11px}.bolinha>span[data-v-750fd9e2]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.navbar[data-v-750fd9e2]{background:hsla(0,0%,100%,.5)}.imagem-emp[data-v-750fd9e2]{max-height:55px}#btn-navbar-toggler[data-v-750fd9e2]{outline:none}@media screen and (max-width:992px){#navbarToggler[data-v-750fd9e2]{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-750fd9e2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Navbar.vue
// module id = kuQO
// module chunks = 42